import React from "react";

function profile() {
  return (
    <h1
      style={{
        fontSize: "2rem",
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      Welcome User!! 🖐🖐
    </h1>
  );
}

export default profile;
